/**
 * Normalize a phone number to E.164 for schema.org. US/CA 10-digit numbers
 * become `+1XXXXXXXXXX`; any other non-empty input is passed through unchanged
 * (use libphonenumber-js for non-US/CA if ever needed — already in the repo);
 * null/empty returns null.
 */
export const normalizePhone = (phone?: string | null): string | null => {
  const cleaned = `${phone ?? ''}`.replace(/\D/g, '');
  if (/^\d{10}$/.test(cleaned)) return `+1${cleaned}`;
  if (cleaned) return phone ?? null;
  return null;
};
